import './styles.styl'
import React from 'react'

export default class UIComponent extends React.Component {
  componentWillMount () {
    if (this.props.fetched === false && this.props.fetching === false) {
      this.props.loadCredentials()
    }
  }

  destroy (name, id) {
    if (!window.confirm(`Weet u zeker dat u credentials "${name}" wilt verwijderen? Dit kan niet ongedaan worden gemaakt en de gekoppelde clients kunnen niet meer inloggen.`)) {
      return
    }

    console.warn(`@TODO: destroy credential ${id}`)
  }

  render () {
    const {
      fetched,
      fetching,
      list
    } = this.props

    let content = null

    if (fetched === false) {
      content = (
        <div className='alert alert-primary'>
          <strong>Geen data...</strong><br />
          <a onClick={() => this.props.loadCredentials()}>Klik hier</a> om het opnieuw te proberen.
        </div>
      )
    }

    if (fetching === true) {
      content = (
        <div className='alert alert-primary'>
          <strong>Momentje...</strong><br />
          We halen de API credentials data op.
        </div>
      )
    }

    if (fetched === true) {
      const rows = list.map((customer, index) => {
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td><code>{customer.clientId}</code></td>
            <td><code>{customer.clientSecret}</code></td>
            <td><code>{customer.redirectURI}</code></td>
            <td>{customer.name}</td>
            <td>
              <button type='button' className='btn btn-sm btn-danger btn-rounded' onClick={() => this.destroy(customer.name, customer.id)}><i className='fa fa-times' /> Verwijder</button>
            </td>
          </tr>
        )
      })
      content = (
        <div className='page-inner'>
          <table className='table' cellPadding='0' cellSpacing='0'>
            <thead>
              <tr>
                <th width={40}>#</th>
                <th width={100}>Client ID</th>
                <th>Secret</th>
                <th width={200}>URI</th>
                <th>Naam</th>
                <th width={100} />
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      )
    }

    return (
      <div className='page'>
        <header className='header'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 col-sm-6'>
                <h1>API credentials</h1>
              </div>
              <div className='col-12 col-sm-6 text-align-right'>
                <button type='button' className='btn btn-success btn-rounded btn-add'><i className='fa fa-plus' /> Nieuwe credentials</button>
              </div>
            </div>
          </div>
        </header>

        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/credentials/component.js